module.exports = __webpack_public_path__ + "img/Nothing for Juice.b0069787.jpg";